<template>
  <main>
    <h1 style="margin-top: 30px">{{ currentData.name }}</h1>
    <div class="box">
      <div class="box__video">
        <bqh-video :url="currentData.url" :poster="currentData.poster" />
      </div>
      <aside>
        <h2>
          <div>目录</div>
        </h2>
        <el-scrollbar>
            <el-tree :data="data" :props="defaultProps" @node-click="onChange"></el-tree>
        </el-scrollbar>
      </aside>
    </div>
  </main>
</template>

<script>
import { reactive, getCurrentInstance } from '@vue/composition-api';
export default {
  name: 'Box',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const internalInstance = getCurrentInstance()
    const that = internalInstance.proxy;
    const dir = reactive({
      prop: that.$route.params && that.$route.params.id,
    })
    const currentData = reactive({
        url: decodeURI(that.$route.query && that.$route.query.url),
        name: decodeURI(that.$route.query && that.$route.query.name),
    })
    const defaultProps = reactive({
      children: 'children',
      label: 'name'
    })
    function onChange(prop) {
      console.log(prop);
      dir.prop = prop.id;
      that.$router.push({ url: '/video-', params: { id: prop.id } ,query:{url:prop.collectionfile,name:prop.name}});
      currentData.url = prop.collectionfile;
      currentData.name = prop.name;
    }
      return { dir, currentData, onChange,defaultProps}
  },
}
</script>

<style lang="scss" scoped>
main {
  height: 40rem;
  width: 85rem;
  margin: 1rem auto 0 auto;
  h1 {
    margin: 0.8rem 0;
    font-size: 1.2rem;
  }
    .el-tree {
        position: relative;
        cursor: default;
         background: #2b3541;
         color: #8d8f8e;
    }
  .box {
    height: 40rem;
    display: flex;
    flex-flow: row;
    &__video {
      flex: 1;
    }
    aside {
      width: 25rem;
      height: 100%;
      background: #2b3541;
      color: #8d8f8e;
      display: flex;
      flex-flow: column;
      h2 {
        margin: 0.8rem;
        > div {
          padding-left: 0.5rem;
          border-left: 0.3rem solid;
          line-height: 1;
          color: #0079fe;
        }
      }
      .el-scrollbar {
        flex: 1;
        ul {
          li {
            padding: 0.8rem 1rem 0 1rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            cursor: pointer;
            &.selected {
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
